// -----------------------------------------------------------------------
// <copyright company="Microsoft Corporation">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import type { ITokenRetriever } from '../types/index';
import { OnePlayerError } from './onePlayerError';

export async function navigateIframeToEmbedAsync(
  iframe: HTMLIFrameElement,
  embedSrc: string,
  tokenRetriever: ITokenRetriever
): Promise<void> {
  let accessToken: string;
  try {
    accessToken = await tokenRetriever.getTokenAsync('SPO', embedSrc);
  } catch (error: unknown) {
    throw OnePlayerError.createGenericError('fatal', 'loadIframe', 'getTokenFailed', error);
  }

  return new Promise((resolve, reject) => {
    iframe.onload = () => {
      resolve();
    };
    iframe.onerror = (error) => {
      reject(error);
    };

    const root = iframe.contentDocument!;
    if (!root.body) {
      root.createElement('body');
    }

    // Create a form that will post to the embed url
    const form = root.createElement('form');
    form.action = embedSrc;
    form.method = 'POST';
    form.style.visibility = 'hidden';
    form.target = '_self';

    // Create a hidden input element to contain the access_token
    const input = root.createElement('input');
    input.type = 'hidden';
    input.name = 'access_token';
    input.value = accessToken;
    form.appendChild(input);

    // Add the form to the iframe and submit it, which will cause the iframe to navigate to the embed URL
    root.body.appendChild(form);
    form.submit();
  });
}
